import React from 'react';

export const BookingSvg: React.FunctionComponent = () => (
  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z"
      fill="url(#paint0_linear_66_516)"
    />
    <path
      d="M19.0058 29.8304H33.9981C34.356 29.8304 34.6749 29.601 34.7887 29.261L38.1203 19.2662C38.2048 19.0124 38.1626 18.7326 38.0048 18.5154C37.8486 18.2982 37.5981 18.1697 37.3297 18.1697H16.2753L14.2442 12.0758C14.1303 11.7359 13.8115 11.5065 13.4536 11.5065H10.6767C10.2163 11.5065 9.84387 11.879 9.84387 12.3394C9.84387 12.7998 10.2164 13.1723 10.6767 13.1723H12.8533L17.9305 28.4078C17.0894 28.8105 16.5071 29.6702 16.5071 30.6633C16.5071 32.0412 17.6279 33.1621 19.0058 33.1621H19.9921C19.8987 33.4239 19.8387 33.7015 19.8387 33.9949C19.8387 35.3729 20.9595 36.4937 22.3374 36.4937C23.7152 36.4937 24.8361 35.3728 24.8361 33.9949C24.8361 33.7015 24.776 33.4239 24.6826 33.1621H29.9869C29.8935 33.4239 29.8334 33.7015 29.8334 33.9949C29.8334 35.3729 30.9543 36.4937 32.3322 36.4937C33.71 36.4937 34.8309 35.3728 34.8309 33.9949C34.8309 32.6171 33.71 31.4962 32.3322 31.4962H19.0058C18.5471 31.4962 18.1729 31.1229 18.1729 30.6633C18.1729 30.2038 18.547 29.8304 19.0058 29.8304ZM29.8579 25.4642L30.6908 22.1326C30.8014 21.6852 31.2471 21.4152 31.701 21.5266C32.1484 21.638 32.4184 22.0902 32.3078 22.536L31.4749 25.8676C31.3635 26.3149 30.9102 26.5848 30.4647 26.4735C30.0174 26.3621 29.7473 25.9099 29.8579 25.4642ZM25.669 22.3342C25.669 21.8738 26.0415 21.5013 26.5018 21.5013C26.9622 21.5013 27.3347 21.8738 27.3347 22.3342V25.6658C27.3347 26.1262 26.9622 26.4987 26.5018 26.4987C26.0414 26.4987 25.669 26.1261 25.669 25.6658V22.3342ZM21.3027 21.5266C21.7404 21.4135 22.2024 21.6852 22.313 22.1326L23.1459 25.4642C23.2565 25.9099 22.9864 26.3621 22.5391 26.4736C22.1026 26.5853 21.6416 26.3201 21.5289 25.8677L20.696 22.5361C20.5854 22.0902 20.8554 21.638 21.3027 21.5266Z"
      fill="url(#paint1_linear_66_516)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_66_516"
        x1="24"
        y1="48"
        x2="24"
        y2="0"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFBEF9" />
        <stop offset="1" stopColor="#FFF1FF" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_66_516"
        x1="24.0034"
        y1="11.5065"
        x2="24.0034"
        y2="36.4937"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#A93AFF" />
        <stop offset="1" stopColor="#FF81FF" />
      </linearGradient>
    </defs>
  </svg>
);
